<script>
import breakpoints from '../../scripts/breakpoints';
export default {
	data() {
		return {
			isLg: false,
			isMd: false,
			isSm: false,
			isXs: false,
			is2Xs: false,
			is3Xs: false
		};
	},

	created() {
		this.getIsMob(true);
		window.addEventListener('resize', this.getIsMob);
	},

	unmounted() {
		window.removeEventListener('resize', this.getIsMob);
	},

	methods: {
		checkBreakpoints() {
			this.isLg = window.innerWidth <= breakpoints['lg-max'];
			this.isMd = window.innerWidth <= breakpoints['md-max'];
			this.isSm = window.innerWidth <= breakpoints['sm-max'];
			this.isXs = window.innerWidth <= breakpoints['xs-max'];
			this.is2Xs = window.innerWidth <= breakpoints['2xs-max'];
			this.is3Xs = window.innerWidth <= breakpoints['3xs-max'];
		},

		getIsMob(immediately) {
			if (immediately) {
				this.checkBreakpoints();
			} else {
				clearTimeout(this.isMobTimeout);
				this.isMobTimeout = setTimeout(() => {
					this.checkBreakpoints();
				}, 500);
			}
		}
	}
};
</script>